<template>
  <van-field
    class="input"
    v-model="inputValue"
    v-bind="$attrs"
    v-on="$listeners"
    :clearable="true"
    :border="false"
    :class="{ 'has-slot': hasSlot, 'error-border': errorBorder }"
    @input="inputEvent"
  >
    <template #left-icon>
      <slot name="left-icon"></slot>
    </template>
    <template #button>
      <div class="button">
        <slot name="button"></slot>
      </div>
    </template>
  </van-field>
</template>

<script>
export default {
  name: 'Input',
  mixins: ['update:value'],
  props: {
    value: {
      type: [String, Number],
      default: undefined
    },
    errorBorder: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      inputValue: this.value
    };
  },
  watch: {
    value(newValue) {
      this.inputValue = newValue;
    }
  },
  computed: {
    hasSlot() {
      return !!this.$slots?.button;
    }
  },
  methods: {
    inputEvent(value) {
      this.$emit('update:value', value);
    }
  }
};
</script>

<style lang="scss" scoped>
.input {
  box-sizing: border-box;
  padding: 0 20px;
  background-color: var(--block-bg-light-color);
  border-radius: var(--border-radius);
  font-size: 24px;
  color: var(--text-color);

  &.has-slot {
    padding-right: 4px;
  }

  &.error-border {
    border: 1px solid var(--error-color);
  }

  .button {
    height: 92px;
  }

  ::v-deep .van-icon-clear {
    font-size: 24px;
  }

  ::v-deep .van-field__left-icon {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-right: 20px;
  }
}
</style>
